import { useEffect, useState } from 'react';
import { CreateQuestionnaireTimepointAction } from '@actions/Admin/Questionnaire/CreateQuestionnaireTimepointAction';

/** Runs the new timepoint dialog. The fields start empty each time the dialog opens. */
export const useTimepointDialogController = (open: boolean, onSaved: () => void) => {
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    setCode('');
    setName('');
    setError(null);
  }, [open]);

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    const response = await new CreateQuestionnaireTimepointAction().Execute({ code: code, name: name });
    setSaving(false);
    if (response.status !== 'SUCCESS') {
      setError(response.statusMessage);
      return;
    }
    onSaved();
  };

  return {
    code,
    name,
    saving,
    error,
    canSave: !!code.trim() && !!name.trim() && !saving,
    handleCodeChange: setCode,
    handleNameChange: setName,
    handleSave,
  };
};
